export default "<img-zoom>\n\n</img-zoom>";